module.exports = __webpack_public_path__ + "img/OldStock.51d475f2.png";